import If from './If/If'
import { types } from './types';

function Actions(action, showAlert, variables, setOpenVariable, variableRender, automId, automVersionId, automDetail) {
    if (action.actionName === types.IF || action.actionName === types.ELSEIF) {
        return <If action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}
            variableRender={variableRender} automId={automId} automVersionId={automVersionId} automDetail={automDetail} />;
    }
}

export default Actions;
